<div class="fruit-icon-editor">
  <div class="fruit-icon-editor__header">
    <h3 class="fruit-icon-editor__header-title">Fruit Icons</h3>
    <button type="button" class="fruit-icon-editor__close-btn" (click)="onClose()" aria-label="Close">&times;</button>
  </div>
  <div class="fruit-icon-editor__body">
    <!-- Icon grid: select which icon to draw -->
    <div class="fruit-icon-editor__section">
      <label class="fruit-icon-editor__label">Select icon</label>
      <div class="fruit-icon-editor__grid">
        <button
          type="button"
          *ngFor="let key of iconKeys"
          class="fruit-icon-editor__icon-btn"
          [class.fruit-icon-editor__icon-btn--selected]="selectedIconKey === key"
          (click)="selectIcon(key)"
          [attr.aria-label]="'Select ' + key"
        >
          <img [src]="getIconUrl(key)" [alt]="key" class="fruit-icon-editor__icon-img" />
        </button>
      </div>
    </div>

    <!-- In / Out (edit mode only) -->
    <div class="fruit-icon-editor__section" *ngIf="isEditMode">
      <label class="fruit-icon-editor__label">In</label>
      <div class="fruit-icon-editor__time-row">
        <div class="fruit-icon-editor__time-input-wrap">
          <input
            type="text"
            class="fruit-icon-editor__time-input"
            [value]="inTimecode"
            (blur)="onInTimeBlur($event)"
            placeholder="00:00:00.000"
          />
          <button
            type="button"
            class="fruit-icon-editor__time-now-btn"
            title="Set to current playhead time"
            (click)="setInToPlayhead()"
            aria-label="Set In to playhead"
          >
            Now
          </button>
        </div>
      </div>
      <label class="fruit-icon-editor__label">Out</label>
      <div class="fruit-icon-editor__time-row">
        <div class="fruit-icon-editor__time-input-wrap">
          <input
            type="text"
            class="fruit-icon-editor__time-input"
            [value]="outTimecode"
            (blur)="onOutTimeBlur($event)"
            placeholder="00:00:00.000"
          />
          <button
            type="button"
            class="fruit-icon-editor__time-now-btn"
            title="Set to current playhead time"
            (click)="setOutToPlayhead()"
            aria-label="Set Out to playhead"
          >
            Now
          </button>
        </div>
      </div>
    </div>

    <!-- Scale (0.1 - 3.0) -->
    <div class="fruit-icon-editor__section">
      <label class="fruit-icon-editor__label">Scale</label>
      <div class="fruit-icon-editor__scale-row">
        <input
          type="range"
          class="fruit-icon-editor__slider"
          [min]="scaleMin"
          [max]="scaleMax"
          [step]="scaleStep"
          [value]="scale"
          (input)="onScaleChange(($any($event.target).value))"
        />
        <input
          type="number"
          class="fruit-icon-editor__number"
          [min]="scaleMin"
          [max]="scaleMax"
          [step]="scaleStep"
          [ngModel]="scale"
          (ngModelChange)="onScaleChange($event)"
        />
      </div>
    </div>

    <!-- Rotation (0 - 360°) -->
    <div class="fruit-icon-editor__section">
      <label class="fruit-icon-editor__label">Rotation (°)</label>
      <div class="fruit-icon-editor__scale-row">
        <input
          type="range"
          class="fruit-icon-editor__slider"
          [min]="rotationMin"
          [max]="rotationMax"
          [value]="rotationDeg"
          (input)="onRotationChange(($any($event.target).value))"
        />
        <input
          type="number"
          class="fruit-icon-editor__number"
          [min]="rotationMin"
          [max]="rotationMax"
          [ngModel]="rotationDeg"
          (ngModelChange)="onRotationChange($event)"
        />
      </div>
    </div>
  </div>
  <div class="fruit-icon-editor__footer">
    <button type="button" class="fruit-icon-editor__save-btn" (click)="onSave()">Save Changes</button>
  </div>
</div>
